"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const gsapObj = {
    init() {
        var _a;
        Array.from((_a = document.querySelectorAll(".section--parallax-gallery-large, .block--parallax-gallery-large")) !== null && _a !== void 0 ? _a : []).forEach((el) => {
            var _a;
            const galleryEl = (_a = el.querySelector(".parallax-grid")) !== null && _a !== void 0 ? _a : undefined;
            if (galleryEl) {
                const parallaxGalleryInit = () => __awaiter(this, void 0, void 0, function* () {
                    const ParallaxGalleryLarge = yield import("./modules/ParallaxGalleryLarge");
                    ParallaxGalleryLarge.default.create(galleryEl, el);
                });
                const parallaxGallerySwiperInit = () => __awaiter(this, void 0, void 0, function* () {
                    const ParallaxGallerySwiper = yield import("./modules/ParallaxGallerySwiper");
                    ParallaxGallerySwiper.default.create(galleryEl);
                });
                if (window.innerWidth > 991) {
                    parallaxGalleryInit();
                }
                else {
                    parallaxGallerySwiperInit();
                }
            }
        });
    },
};
document.addEventListener("DOMContentLoaded", () => {
    gsapObj.init();
});
